import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  chip: {
    fontWeight: 400,
    height: '21px',
    textTransform: 'uppercase',
  },
  rowText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: '0em',
    maxWidth: 350,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0em',
  },
  adopted: {
    backgroundColor: colors.green[100],
    color: colors.green[900],
  },
  pending: {
    backgroundColor: colors.orange[100],
    color: colors.orange[900],
  },
  inProgress: {
    backgroundColor: colors.blue[100],
    color: colors.blue[900],
  },
  overdue: {
    backgroundColor: colors.red[100],
    color: colors.red[900],
  },
  riskAssumed: {
    backgroundColor: colors.purple[100],
    color: colors.purple[900],
  },
  treated: {
    backgroundColor: colors.green[500],
    color: colors.common.white,
  },
  waitingAnswer: {
    backgroundColor: colors.yellow[800],
    color: colors.common.white,
  },
}))

export default styles
